<div class="error">
  <div class="error__body">
    <p>
      Page not Found <br />
      <span class="pointer" routerLink="/">Return HOME</span>
    </p>
  </div>
</div>
